import * as React from 'react';
import { SkeletonLoader } from 'uxp/components';
import { lazyComponent } from '../../lazy';

/**
 * Shared lazy wrapper for template render components.
 *
 * Each template's render component is code-split into its own `tpl-*` chunk (the
 * `webpackChunkName` magic comment lives at the call site's `import()`). Template
 * *metadata* is registered eagerly in the sibling `*.register.ts`; only this heavy
 * render code loads on demand — when the widget first renders in the canvas, a
 * nested card, or the host/standalone widget page.
 *
 * `lazyComponent` self-wraps `<Suspense>`, so this works even where the widget is
 * rendered via a bare `React.createElement(template.template, …)` with no external
 * Suspense boundary. The fallback is a skeleton (not blank) so the canvas doesn't
 * flash on first render. Single control point for the fallback.
 */
const fallback = <SkeletonLoader />;

export function lazyTemplate<P = any>(
    load: () => Promise<{ default: React.ComponentType<P> }>
) {
    return lazyComponent<P>(load, fallback);
}
